import { Component, HostListener, ChangeDetectionStrategy } from '@angular/core';
import { LibTableRecordActionComponent } from '@tuain/ng-forms';
import { tuainFormsBaseModules, tuainBaseComponents } from '@components/tuain.modules';

@Component({
  standalone: true,
  selector: 'app-upload-custom-action',
  imports: [...tuainFormsBaseModules, ...tuainBaseComponents],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // La visibilidad se aplica en el host y no con un `@if` alrededor del `<ng-content>`: el
  // contenido proyectado no se puede volver a proyectar si se destruye. `null` deja que
  // manden los estilos estáticos cuando la acción es visible.
  host: {
    '[style.display]': "visible() ? null : 'none'",
  },
})
export class AppUploadCustomActionComponent extends LibTableRecordActionComponent {
  @HostListener('click', ['$event'])
  handleClick(event: MouseEvent) {
    event.stopPropagation(); // opcional si no quieres que burbujee
    this.onActivate();
  }
}
